import { memo } from 'react';
import styled from 'styled-components';
import { useSelector } from 'react-redux';

import { Post } from './Post.jsx';
import { PrizeBanner } from './PrizeBanner/PrizeBanner.jsx';

import { useGetPostTiles } from './hooks/useGetPostTiles';
import { useScrollContext } from '../../contexts/ScrollContext.jsx';
import { useCampaignContext } from '../../contexts/CampaignContext.jsx';
import { RESTRICTED_SITE_ADMIN } from '../../../../lib/utils/constants/UserTypes';

export const SinglePost = memo(({ post, campaignUuid, campaignEndDate }) => {
  const { postRefs } = useScrollContext();
  const { campaign } = useCampaignContext();
  const tiles = useGetPostTiles({ uuid: post.uuid });
  const { userType } = useSelector(state => state.currentUser);
  const { prize } = post;

  return (
    <Container
      id={post.uuid}
      ref={ref => {
        postRefs.current[post.uuid] = ref;
      }}
    >
      {prize && userType !== RESTRICTED_SITE_ADMIN && !campaign.isArchived && (
        <PrizeBanner prize={prize} />
      )}
      <Post
        tiles={tiles}
        campaignEndDate={campaignEndDate}
        campaignId={campaignUuid}
        archivedCampaign={campaign.isArchived}
        post={post}
      />
    </Container>
  );
});

SinglePost.displayName = 'SinglePost';

const Container = styled.div``;
